/* INTEGY V763.2 | visible-card count and single-result presentation guards.
 * Never claims that an unverified product is in stock or available for purchase.
 * The search/stock owners continue to own product membership and pagination. */
(function () {
  'use strict';
  if (window.IntegyV763RenderedCountGuard) return;
  window.IntegyV763RenderedCountGuard = true;
  var search = /\/search\/?$/i.test(location.pathname);
  var traxxas = /^\/collections\/hopups-for-traxxas\/?$/i.test(location.pathname);
  if (!search && !traxxas) return;
  var queued = false;
  var lastGrid = null, firstSeen = 0;
  function one(q, ctx) { try { return (ctx || document).querySelector(q); } catch (e) { return null; } }
  function cards(grid) {
    return grid ? Array.prototype.filter.call(grid.children, function (c) {
      return c.nodeType === 1 && c.matches('article.integy-v426-search-card,[data-product-item],.productgrid--item')
        && !c.hidden && c.getAttribute('aria-hidden') !== 'true' && getComputedStyle(c).display !== 'none' && getComputedStyle(c).visibility !== 'hidden';
    }) : [];
  }
  function safeFallback(card) {
    if (card.getAttribute('data-integy-v529-commerce-state') === 'done' || card.getAttribute('data-integy-v763-safe-fallback') === 'true') return;
    card.setAttribute('data-integy-v763-safe-fallback', 'true');
    var price = one('[data-integy-v529-current-price]', card), stock = one('.integy-v456-search-stock', card),
        action = one('.integy-v547-direct-actions', card);
    if (price && /checking|loading/i.test(price.textContent)) price.textContent = 'See price on product page';
    if (stock && /checking|loading/i.test(stock.textContent)) stock.textContent = 'Check availability on product page';
    if (action && /checking/i.test(action.textContent)) {
      var raw = card.getAttribute('data-integy-v529-product-url') || '';
      var link = one('a[href*="/products/"]', card);
      var href = raw || (link && link.href) || '';
      if (href) {
        var a = document.createElement('a');
        a.href = href; a.className = 'productitem--action-trigger button-primary integy-v547-choose-options';
        a.textContent = 'View Details'; action.replaceChildren(a);
      }
    }
  }
  function searchText(count, total, phrase) {
    return (count < total ? 'Showing ' + count + ' of ' + total : total) + ' ' + phrase;
  }
  function syncSearch() {
    /* Preserve V742's six-card special case without the old competing V761 observer. */
    var q = new URLSearchParams(location.search).get('q') || '';
    if (q.trim().toLowerCase() === 'truer') {
      var special = one('[data-integy-v742-count]');
      if (special && !special.hidden) {
        var native = special.querySelectorAll('.productgrid--items > .productgrid--item');
        if (native.length) {
          var correctTitle = native.length + ' products matching “truer” — Integy Official Shop';
          if (document.title !== correctTitle) document.title = correctTitle;
          var header = one('.search--section .productgrid--masthead h1.visually-hidden');
          if (header) header.textContent = native.length + ' products matching “truer”';
        }
      }
    }
    var owner = one('#integy-v520-search-results:not([hidden])');
    if (!owner) return;
    var grid = one('.integy-v520-search-grid', owner), title = one('[data-integy-v725-result-count]', owner);
    if (!grid || !title) return;
    var list = cards(grid), count = list.length;
    grid.classList.toggle('integy-v763-single-result', count === 1);
    if (!count) return;
    grid.setAttribute('data-v763-rendered-cards', String(count));
    grid.setAttribute('data-result-count', String(count));
    if (grid !== lastGrid) { lastGrid = grid; firstSeen = Date.now(); }
    var text = String(title.textContent || '').replace(/\s+/g, ' ').trim();
    var match = text.match(/^(?:Showing\s+)?(\d+)(?:\s+of\s+(\d+))?\s+(products?\s+matching\s+.+|compatible products?\s+for\s+.+|products?\s+with\s+SKU\s+number\s+beginning\s+.+)$/i);
    if (match) {
      var total = Math.max(count, Number(match[2] || match[1]));
      var accurate = searchText(count, total, match[3]);
      if (accurate !== text) {
        title.textContent = accurate;
        var current = document.title;
        var suffix = current.match(/\s+[–—|]\s+(.+)$/);
        document.title = accurate + ' — ' + (suffix ? suffix[1] : 'Integy Official Shop');
      }
      var more = one('[data-integy-v520-load-more]', owner);
      if (more && count < total) {
        var limit = window.matchMedia('(max-width:740px)').matches ? 36 : window.matchMedia('(max-width:1100px)').matches ? 48 : 72;
        var caption = 'Load ' + Math.min(limit, total - count) + ' more products';
        if (more.textContent !== caption) more.textContent = caption;
      }
    }
    // This is only a safe label fallback; product JSON may still hydrate later.
    if (Date.now() - firstSeen > 8500) list.forEach(safeFallback);
  }
  /* INTEGY V764 count integrity: describe displayed product cards, never
     substitute an unverified per-card stock status for live availability. */
  /* V764.4 STALE COUNTER REPAIR: page-local counts track actual rendered
     cards through async filtering, even while render-settled flags transition.
     Stock counts and aggregate total stay owned by the canonical stock engine. */
  function syncTraxxas() {
    var grid = one('main#site-main .productgrid--items,main#site-main [data-productgrid-items]');
    if (!grid || grid.closest('[hidden],[aria-hidden="true"]')) return;
    var list = cards(grid);
    var count = list.length;
    grid.setAttribute('data-v763-rendered-cards', String(count));
    var label = one('[data-integy-v763-page-results]');
    if (!label) {
      label = document.createElement('p');
      label.className = 'integy-v763-page-count';
      label.setAttribute('data-integy-v763-page-results', '');
      label.setAttribute('role', 'status');
    }
    if (label.parentNode !== grid.parentNode || label.nextElementSibling !== grid)
      grid.parentNode.insertBefore(label, grid);
    var busy = grid.getAttribute('aria-busy') === 'true' ||
               grid.classList.contains('integy-v634-stock-settling');
    var settled = grid.getAttribute('data-integy-v634-render-settled') === 'true';
    var copy = busy ? 'Updating product results…'
                    : count ? 'Showing ' + count + ' product card' + (count === 1 ? '' : 's') + ' on this page'
                    : settled ? 'No product cards displayed on this page'
                    : 'Loading product results…';
    if (label.textContent !== copy) label.textContent = copy;
    label.setAttribute('data-integy-v764-rendered-cards', String(count));
  }
  function run() { queued = false; if (search) syncSearch(); else syncTraxxas(); }
  function schedule() {
    if (queued) return; queued = true;
    (window.requestAnimationFrame || function (fn) { setTimeout(fn, 20); })(run);
  }
  function boot() {
    schedule();
    var host = one('main#site-main') || document.body;
    if (host && window.MutationObserver) new MutationObserver(function (records) {
      /* V763.5: stock verification frequently changes attributes, not nodes.
         Only observe attributes affecting the visible/verified card counts. */
      if (records.some(function (r) { return r.type === 'childList' || r.type === 'attributes'; })) schedule();
    }).observe(host, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['hidden', 'aria-hidden', 'class', 'style',
        'data-integy-v548-stock-verified', 'data-integy-v634-render-settled',
        'data-integy-v634-stock-settled'] });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('integy:v634:stock-settled', schedule);
    [800, 2500, 5000, 9000, 14000, 20000].forEach(function (ms) { setTimeout(schedule, ms); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();